export default {
  calendarEventModalOpened: 'calendarEventModalOpened'
}
